import script from "./PasswordType.vue?vue&type=script&lang=js"
export * from "./PasswordType.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__